import styled, { css } from 'styled-components';
import { ModalLayout, Text } from 'components';
import { theme, toRem } from 'design';
import { Subtitle } from 'modals/styles';

interface ILayoutProps {
  maxWidth?: number;
  center?: boolean;
}

export const Layout = styled(ModalLayout)<ILayoutProps>`
  width: 100%;
  max-width: ${toRem(600)};

  ${({ center }) =>
    center &&
    css`
      align-items: center;
    `}

  header {
    padding-bottom: ${toRem(16)};
  }
`;

export const StyledSubtitle = styled(Subtitle)`
  font-size: ${toRem(14)};
  margin-top: ${toRem(4)};
  line-height: ${toRem(18)};
`;

export const ResultsWrapper = styled.div`
  display: flex;
  flex-flow: column;
  width: 100%;
  align-items: start;
  margin-bottom: ${toRem(16)};
`;

export const Wrapper = styled.div<ILayoutProps>`
  display: flex;
  flex-flow: column;
  width: 100%;
  align-items: start;

  ${({ center }) =>
    center &&
    css`
      align-items: center;
    `}

  button {
    width: 100%;
  }
`;

export const ContentFooter = styled.div`
  display: flex;
  flex-flow: column;
  width: 100%;
  align-items: center;
  margin-top: ${toRem(18)};
`;

export const FooterAction = styled.div``;

export const SearchBar = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: ${toRem(16)};
`;

export const ActionText = styled(Text)`
  margin-right: ${toRem(4)};
  color: ${theme.color.primary[500]};

  &:hover {
    cursor: pointer;
    color: ${theme.color.primary[600]};
  }
`;

export const SplitScreen = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 100%;
  grid-gap: ${toRem(16)};

  border: ${toRem(1)} solid ${theme.color.neutral[200]};
  border-radius: ${toRem(theme.borderRadius.small)};
  margin-bottom: ${toRem(16)};
  background-color: ${theme.color.neutral[25]};

  @media (min-width: ${theme.breakpoint.small}px) {
    grid-template-columns: repeat(1, minmax(auto, 100%)) auto repeat(1, minmax(auto, 100%));
    align-items: center;
    grid-gap: ${toRem(16)};
  }
`;
